<template>
  <div v-if="dataIsLoad">
    <div class="des-tabs-block row">
      <div class="des-tab col-6" :class="{ active: infoIndex === 0 }" @click="showMoreInfo(0)">
        商品描述
      </div>
      <div class="des-tab col-6" :class="{ active: infoIndex === 1 }" @click="showMoreInfo(1)">
        其他資訊
      </div>
      <div
        class="des-content col-12"
        :class="{ show: infoIndex === 0, hide: infoIndex !== 0 }"
        v-html="selectedFoodSpec.Product.Description"
      />
      <div
        class="des-content col-12"
        :class="{ show: infoIndex === 1, hide: infoIndex !== 1 }"
        v-html="selectedFoodSpec.Product.ShippingGuide"
      />
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { storeToRefs } from 'pinia';

import useShopContentStore from '@global/stores/useShopContentStore';

const shopContentStore = useShopContentStore();
const { dataIsLoad, selectedFoodSpec } = storeToRefs(shopContentStore);

const infoIndex = ref(0);

function showMoreInfo(index) {
  infoIndex.value = index;
}
</script>
